import script from "./ItemMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemMenu.vue?vue&type=script&setup=true&lang=js"

import "./ItemMenu.vue?vue&type=style&index=0&id=fdbee5be&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdbee5be"]])

export default __exports__